import IntereneRoot from '@/views/dataReport';
import ipDeviceQuery from './ipDeviceQuery';
import jsDeviceIntervene from './jsDeviceIntervene';
import {INTERVENE_ROOT} from '@/enmus/PageNames';
export default {
    path: 'intervene',
    name: 'intervene',
    component: IntereneRoot,
    meta: {
        name: INTERVENE_ROOT,
        title: '干预管理'
    },
    children: [
        ipDeviceQuery,
        jsDeviceIntervene
    ]
};